export default __webpack_public_path__ + "0be2a4d7fcea2541a22081dc6e0dcb66.mp3";